define('SuiteDynamics.B2BPromoMessaging.PLPModifications',
	[
	],
	function (
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
		}
	};
});
